import React from 'react'
import {useSelector} from 'react-redux'
// import {getCurrencyCode} from 'modules/meta/selectors'
import {toggle} from 'opticks'

import {Avatar, AvatarType} from '@daedalus/atlas/Avatar'
import {getUserName} from '@daedalus/core/src/auth/business/authentication'
import {getAvailableRedeemableVioCash} from '@daedalus/core/src/auth/modules/selectors'
import {User} from '@daedalus/core/src/auth/types/Cognito'

import {CashbackTag} from '../../../cashbackDeals/CashbackTag'
import {GemsTextTag} from '../../../privateDeal/gems/GemsTextTag'

type Props = {
  user: User | null
  hasGemsTag?: boolean
}

export const UserAvatar = ({user, hasGemsTag = true}: Props) => {
  const picture = user?.attributes?.picture

  const availableRedeemableVioCash = useSelector(getAvailableRedeemableVioCash)
  const showCashbackTag =
    availableRedeemableVioCash > 0 &&
    toggle(
      '0603e523-vio-cash-sid',
      () => false,
      () => true
    )

  /* FIXME 0603e523-vio-cash-sid: Having issues with importing the selector due to missing alias
  const currency = useSelector(getCurrencyCode)
  */

  return (
    <Avatar
      picture={picture}
      type={picture ? AvatarType.Picture : AvatarType.Icon}
      name={getUserName(user)}
      bottomIcon={
        showCashbackTag ? (
          <CashbackTag
            variant="valueOnly"
            accountValue={availableRedeemableVioCash}
            currency="EUR"
            allowClickPropagation
          />
        ) : hasGemsTag ? (
          <GemsTextTag hasBorder />
        ) : undefined

        /* FIXME: Don't hardcode currencies: 0603e523-vio-cash-sid */
      }
      borderColorPath="border.special.c300"
    />
  )
}
